import React from 'react'
import './recruit_title.scss'

export default ({ title, type }) => {
    return (
        <div className='recruit_title'>
            {type == 1 ?
                <> <div className="title">
                    <span>{title}</span>
                </div>
                </> :
                <>
                    <div className="title">
                        <span>{title}</span>
                    </div>
                </>
            }
        </div>
    )
}
